var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{staticClass:"mediaViewer",attrs:{"visible":_vm.textVisible,"footer":false,"width":600},on:{"cancel":_vm.closeMediaPreviewModal}},[_c('a-icon',{attrs:{"slot":"closeIcon","type":"close-circle","theme":"twoTone"},slot:"closeIcon"}),_c('div',{staticClass:"text"},[_c('p',{staticClass:"textP"},[_vm._v(_vm._s(_vm.contentText))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }